class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();

//     this.form = this.querySelector('form');
//     this.input = this.querySelector('input[type="search"]');
//     this.predictiveSearchResults = this.querySelector('#predictive-search');

//     this.input.addEventListener('input', this.debounce((event) => {
//       this.onChange(event);
//     }, 300).bind(this));

//     this.form.addEventListener('reset', () => {
//         this.onChange({ target: this.input });
//     });
//   }

  constructor() {
    super();

    this.reset = this.querySelector('button[type="reset"]');
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    // store debounced handler (important)
    this.handleInput = this.debounce(this.onChange.bind(this), 300);
    this.input.addEventListener('input', this.handleInput);

    // listen to form reset
    this.addEventListener('reset', () => {
        // wait until browser clears the input
        requestAnimationFrame(() => {
        this.onChange({ target: this.input });
        });
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      this.reset.style.visibility = 'hidden';
      return;
    }
    
    this.reset.style.visibility = 'visible';
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);